import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import { toast, ToastContainer } from 'react-toastify';
import httpService from '../services/http.service';
import { t } from '../utils';
class StartingCashInput extends Component {
    constructor(props) {
        super(props);
        this.storeValue = () => {
            httpService
                .post(`/settings/starting-cash`, {
                value: this.state.inputValue || 0
            })
                .then((response) => {
                if (response.data) {
                    toast.info(t('Saved!', 'تم الحفظ'), {
                        toastId: 'info-toast'
                    });
                }
            });
        };
        this.handleInput = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var startingCashValue = value == '' ? undefined : Number(value);
            this.setState({ inputValue: startingCashValue }, () => this.storeValue());
        };
        this.state = {
            inputValue: this.props.value
        };
    }
    componentDidMount() { }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-3" },
                React.createElement("label", { htmlFor: "starting-cash", className: "form-label" },
                    t('Starting cash', 'الرصيد الافتتاحي'),
                    " (",
                    this.props.currency,
                    ")"),
                React.createElement("input", { type: "number", dir: "ltr", className: `form-control form-control-lg ${this.props.direction == 'rtl' ? 'text-start' : ''}`, value: this.state.inputValue, onFocus: e => e.target.select(), onInput: this.handleInput.bind(this) })),
            React.createElement(ToastContainer, { position: "bottom-left", autoClose: 2000, pauseOnHover: true, theme: "colored", hideProgressBar: true })));
    }
}
export default StartingCashInput;
const element = document.getElementById('starting-cash-input');
if (element) {
    const root = ReactDOM.createRoot(element);
    const props = Object.assign({}, element.dataset);
    root.render(React.createElement(StartingCashInput, Object.assign({ value: 0, direction: 'ltr', currency: '' }, props)));
}
